/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import PropTypes from "prop-types";
import { Divider } from "@blueprintjs/core";
import { Row } from "jsxstyle";
import Button from "components/Button";
import Card from "components/Card";
import Separator from "components/Separator";
import TwoColumnFormLayout from "components/TwoColumnFormLayout";
import CLORatingAgenciesForm from "./CLORatingAgenciesForm";
import CLORatingAgenciesTable from "./CLORatingAgenciesTable";
import useAsync from "hooks/useAsync";
import loadCLORatingsService from "services/clo/loadCLORatingsService";
import PermissionValidator from "components/PermissionValidator";
import { ADMIN_ROLE, DATA_TEAM_ROLE } from "consts";
import browserHistory from "browserHistory";

function CLORatingAgenciesTab({ deal, isNew }) {
  const [agencyToEdit, setAgencyToEdit] = React.useState(null);

  const [fetch, pending, data] = useAsync({
    promiseFn: loadCLORatingsService
  });

  const dealCode = deal.deal_code;

  React.useEffect(() => {
    fetch({ dealCode });
  }, []);

  return (
    <Card>
      <PermissionValidator allowedFor={[ADMIN_ROLE, DATA_TEAM_ROLE]}>
        <TwoColumnFormLayout
          title={agencyToEdit ? "Edit Rating Agency" : "Add Rating Agency"}
        >
          <CLORatingAgenciesForm
            key={agencyToEdit && agencyToEdit.id}
            onCancel={() => setAgencyToEdit(null)}
            onData={() => {
              setAgencyToEdit(null);
              fetch({ dealCode });
            }}
            initialValues={{
              dealCode,
              ...(agencyToEdit
                ? {
                    ...agencyToEdit,
                    entity_id: agencyToEdit.entity_id.entity_id
                  }
                : {})
            }}
          />
        </TwoColumnFormLayout>
        <Divider style={{ margin: "30px 0 30px 0" }} />
      </PermissionValidator>
      <TwoColumnFormLayout title="Rating Agencies">
        <CLORatingAgenciesTable
          data={data}
          pending={pending}
          onReload={() => fetch({ dealCode })}
          onRequestEdit={agency => setAgencyToEdit(agency)}
        />
      </TwoColumnFormLayout>
      {isNew && (
        <React.Fragment>
          <Separator size="lg" />
          <Row className="col-12" justifyContent="flex-end">
            <Button
              intent="primary"
              text="Next"
              onClick={() =>
                browserHistory.push(
                  `/clo/new/${deal.deal_code}/tranche-prices-and-ratings`
                )
              }
            ></Button>
          </Row>
        </React.Fragment>
      )}
    </Card>
  );
}

CLORatingAgenciesTab.propTypes = {
  isActive: PropTypes.bool,
  dealCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  isNew: PropTypes.bool
};

CLORatingAgenciesTab.defaultProps = {
  isActive: false,
  isNew: true
};

export default CLORatingAgenciesTab;
